import React from 'react';

const variants = {
  primary: 'inline-flex items-center justify-center rounded-2xl bg-gradient-accent px-6 py-3 text-sm font-semibold text-white shadow-elevated transition duration-200 hover:shadow-elevated hover:scale-105 focus:outline-none focus:ring-2 focus:ring-orange focus:ring-offset-2',
  secondary: 'inline-flex items-center justify-center rounded-2xl bg-gradient-primary px-6 py-3 text-sm font-semibold text-white shadow-elevated transition duration-200 hover:shadow-elevated hover:scale-105 focus:outline-none focus:ring-2 focus:ring-navy focus:ring-offset-2',
  ghost: 'inline-flex items-center justify-center rounded-2xl border-2 border-navy bg-white px-6 py-3 text-sm font-semibold text-navy transition duration-200 hover:bg-lightgray focus:outline-none focus:ring-2 focus:ring-navy focus:ring-offset-2',
};

function Button({ children, variant = 'primary', type = 'button', onClick, disabled = false, ...props }) {
  const { className = '', ...restProps } = props;

  return (
    <button
      type={type}
      className={`${variants[variant] || variants.primary} ${disabled ? 'cursor-not-allowed opacity-60' : ''} ${className}`}
      onClick={onClick}
      disabled={disabled}
      {...restProps}
    >
      {children}
    </button>
  );
}

export default Button;